var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1941 13.0486C29.1935 13.0479 29.1928 13.0472 29.1921 13.0465L16.9532 0.809326C16.4315 0.287476 15.7379 0 15.0002 0C14.2624 0 13.5688 0.287247 13.0469 0.809097L0.814475 13.0401C0.810355 13.0442 0.806235 13.0486 0.802115 13.0527C-0.269162 14.13 -0.26733 15.878 0.807379 16.9526C1.29838 17.4438 1.94687 17.7283 2.64022 17.758C2.66838 17.7608 2.69676 17.7621 2.72538 17.7621H3.21317V26.768C3.21317 28.55 4.66329 30 6.446 30H11.2342C11.7195 30 12.1132 29.6066 12.1132 29.1211V22.0605C12.1132 21.2473 12.7748 20.5859 13.5881 20.5859H16.4123C17.2256 20.5859 17.8871 21.2473 17.8871 22.0605V29.1211C17.8871 29.6066 18.2806 30 18.7661 30H23.5544C25.3371 30 26.7872 28.55 26.7872 26.768V17.7621H27.2395C27.9771 17.7621 28.6706 17.4749 29.1928 16.953C30.2686 15.8766 30.2691 14.1257 29.1941 13.0486Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeWhiteIcon);
export default __webpack_public_path__ + "static/media/homeWhiteIcon.b8217a1cb472236b4c1311ab24243c8a.svg";
export { ForwardRef as ReactComponent };